module.exports = __webpack_public_path__ + "img/garden_gdzb_2.0069694b.png";